module.exports = __webpack_public_path__ + "img/mahgoub.94acd5bd.jpg";